module.exports = require("../dist/reactnative/core/StickyContainer");